/**
 * !!! made the following manual polyfill adjustments: https://github.com/facebookincubator/create-react-app/pull/3200/files
 */
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/string';          // polyfill for IE11
import 'core-js/fn/array/includes'    // Array.includes(...) polyfill for IE11
import 'core-js/fn/object/values'     // Object.values(...) polyfill for IE11
import 'core-js/modules/es6.symbol'   // Symbol polyfill for IE11

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import WebFontLoader from 'webfontloader';
import ReactGA from 'react-ga'

import db from 'db'
import { enableReactDevTools } from 'lib/utils';
import { store } from './redux/store'
//import registerServiceWorker from './registerServiceWorker'
import App from './App'
import './index.css';
//import { whyDidYouUpdate } from 'why-did-you-update';
//whyDidYouUpdate(React);

/* make Google fonts and material icons available */
WebFontLoader.load({
	google: {
		families: ['Roboto:400,500,700', 'Material Icons'],
	},
});

if (window.location.hostname.startsWith('zeituhr1938')) ReactGA.initialize('UA-114946292-1');

//console.log(`Running app on ${window.location.hostname} in ${process.env.NODE_ENV} build / ${process.env.REACT_APP_ENV} mode`);

enableReactDevTools(['local', 'development', 'staging']); // enable ReactDevTools for development and staging environment only

db.initialize();

ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>,
	document.getElementById('root')
);

// allow advanced caching
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js